import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "o-grid" }
const _hoisted_2 = { class: "o-grid__cell o-grid__cell--12 o-grid__cell--10-1024 infobox" }
const _hoisted_3 = {
  key: 0,
  class: "gev19-infobox--blue summary-label"
}
const _hoisted_4 = {
  key: 1,
  class: "gev19-infobox-filled--blue u-color-white infoitem"
}
const _hoisted_5 = {
  key: 2,
  class: "gev19-infobox-filled--blue u-color-white infoitem"
}
const _hoisted_6 = {
  key: 3,
  class: "gev19-infobox-filled--blue u-color-white infoitem"
}
const _hoisted_7 = {
  key: 4,
  class: "gev19-infobox-filled--blue u-color-white infoitem"
}
const _hoisted_8 = {
  key: 5,
  class: "gev19-infobox-filled--blue u-color-white infoitem"
}
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { key: 2 }
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = { key: 4 }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { key: 2 }
const _hoisted_17 = { key: 3 }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = {
  key: 6,
  class: "gev19-infobox-filled--blue u-color-white infoitem"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon_sprite = _resolveComponent("icon-sprite")!
  const _component_Infotext = _resolveComponent("Infotext")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.zeigeHinweisSchadenfreiBonus && _ctx.istDunkelverarbeitung)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createTextVNode(_toDisplayString(_ctx.piniaStore.state.isMakler === true
            ? "Sofern Ihr Versicherungsnehmer keine Schäden hat, profitiert dieser automatisch " +
              "vom Schadenfrei-Bonus (10%). Bitte beachten Sie, dass dieser Bonus beim ersten " +
              "Schaden nach der ersten Entschädigungszahlung entfällt."
            : "Sie profitieren vom Schadenfrei-Bonus 10 %, weil und solange Sie keine Schäden haben.") + " ", 1),
            (!_ctx.piniaStore.state.isMakler)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  class: "c-notice-icon",
                  "aria-hidden": "true",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.wechsleSichtbarkeit('bonushilfe')))
                }, [
                  _createVNode(_component_icon_sprite, { "icon-name": "icon-info-i" })
                ]))
              : _createCommentVNode("", true),
            _createVNode(_component_Infotext, {
              role: "tooltip",
              id: "bonushilfe",
              name: "bonushilfe",
              text: "Bitte beachten Sie, dass dieser beim ersten Schaden nach der ersten\n            Entschädigungszahlung entfällt."
            })
          ]))
        : _createCommentVNode("", true),
      (_ctx.sfrAusVorbelegung)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, " SFR Stufe " + _toDisplayString(_ctx.piniaStore.state.tarifinformationen.sfrAusVorbelegung) + " wurde berücksichtigt. Stufungsrelevante Schäden aus dem aktuellen Jahr werden automatisch zur nächsten Hauptfälligkeit ermittelt. Eine zusätzliche Erfassung von Schäden des aktuellen Jahres ist deshalb nicht notwendig. ", 1))
        : _createCommentVNode("", true),
      (_ctx.istSonstigesGewerbe)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, " Aufgrund der angegebenen Gewerbeart erfolgt eine gesonderte Antragsprüfung. Der ausgewiesene Beitrag kann sich ggf. erhöhen. "))
        : _createCommentVNode("", true),
      (_ctx.istEeKRabatt)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, " Sie profitieren vom Energie-Bonus wegen der energieeffizienten Bauweise Ihres Gebäudes. "))
        : _createCommentVNode("", true),
      (_ctx.zeigeAnpassungsfaktorMeldung)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, " Aufgrund des Versicherungsbeginns im nächsten Jahr hat sich der Beitrag aufgrund des dann gültigen Anpassungsfaktors geändert. "))
        : _createCommentVNode("", true),
      (
          (_ctx.zusaetzlicheSbLw && _ctx.istDunkelverarbeitung) ||
          (!_ctx.piniaStore.state.isMakler && !_ctx.istDunkelverarbeitung) ||
          _ctx.istKernsanierung ||
          _ctx.props.hinweistext ||
          _ctx.istSbVgvFehlendeVorversicherung
        )
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            (_ctx.zusaetzlicheSbLw && _ctx.istDunkelverarbeitung)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, _cache[1] || (_cache[1] = [
                  _createElementVNode("strong", null, "Hinweis:", -1),
                  _createTextVNode(" Die zusätzliche Selbstbeteiligung je Leitungswasser-Schaden beträgt "),
                  _createElementVNode("strong", null, "750 €", -1)
                ])))
              : _createCommentVNode("", true),
            (_ctx.istSbVgvFehlendeVorversicherung)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _cache[2] || (_cache[2] = _createElementVNode("strong", null, "Hinweis:", -1)),
                  _cache[3] || (_cache[3] = _createTextVNode(" Aufgrund der fehlenden Vorversicherung wird ein beitragsneutraler Selbstbehalt für die Grundgefahren in Höhe von ")),
                  _createElementVNode("strong", null, _toDisplayString(_ctx.formatCurrency(_ctx.hoeheSbVgvFehlendeVorversicherung)), 1),
                  _cache[4] || (_cache[4] = _createTextVNode(" vereinbart. Dieser kann bei schadenfreiem Verlauf nach einem Jahr geprüft werden. "))
                ]))
              : _createCommentVNode("", true),
            (!_ctx.piniaStore.state.isMakler && !_ctx.istDunkelverarbeitung)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _cache[5] || (_cache[5] = _createElementVNode("strong", null, "Hinweis:", -1)),
                  _createTextVNode(" " + _toDisplayString(_ctx.keineDunkelverarbeitungText), 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.props.hinweistext)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 3,
                  innerHTML: _ctx.props.hinweistext
                }, null, 8, _hoisted_12))
              : _createCommentVNode("", true),
            (
            (_ctx.istKernsanierung && !_ctx.piniaStore.state.isMakler) ||
            (_ctx.istFhkVerkaufsprodukt(_ctx.piniaStore.state) && _ctx.istKernsanierung)
          )
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  (_ctx.preisDurchSanierungGesunken)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_14, "Aufgrund der durchgeführten Sanierungen können wir Ihnen ein noch attraktiveres Angebot machen."))
                    : (_openBlock(), _createElementBlock("span", _hoisted_15, "Aufgrund Ihrer weiteren Angaben hat sich Ihr Preis verändert.")),
                  (_ctx.piniaStore.state.tarifinformationen.anpassungZahlungsweise)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                        _cache[6] || (_cache[6] = _createTextVNode(" Dadurch war eine Anpassung Ihrer Zahlungsweise notwendig.")),
                        _cache[7] || (_cache[7] = _createElementVNode("br", null, null, -1)),
                        _createElementVNode("div", null, [
                          _createElementVNode("strong", null, "Der jährliche Beitrag ändert sich von " + _toDisplayString(_ctx.beitragVorKernsanierungJaehrlich) + " auf " + _toDisplayString(_ctx.formatCurrency(_ctx.preisGemZahlungsweise)) + ". ", 1)
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_17, [
                        (!_ctx.istFhkVerkaufsprodukt(_ctx.piniaStore.state))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                              _createElementVNode("strong", null, "Ihr ursprünglicher Preis: " + _toDisplayString(_ctx.beitragVorKernsanierungGemZahlungsweise) + ".", 1)
                            ]))
                          : (_openBlock(), _createElementBlock("div", _hoisted_19, [
                              _createElementVNode("strong", null, "Ihr ursprünglicher Preis: " + _toDisplayString(_ctx.formatCurrency(
                    _ctx.piniaStore.state.ferienhaus.vgv.tarifinformationen.beitragVorKernsanierungGemZahlungsweise,
                  )) + ".", 1)
                            ]))
                      ]))
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (_ctx.piniaStore.state.isMakler && _ctx.istHinweisFuerBlBh)
        ? (_openBlock(), _createElementBlock("div", _hoisted_20, _cache[8] || (_cache[8] = [
            _createElementVNode("strong", null, "Hinweis:", -1),
            _createTextVNode(" Aufgrund Ihrer Angaben prüfen wir Ihren Antrag individuell. Hierdurch können sich Abweichungen ergeben. ")
          ])))
        : _createCommentVNode("", true)
    ])
  ]))
}